<form
  class="page-section fieldset container-harbour-dues d-flex flex-column gap-5 my-5"
  id="harbour_dues_form"
  name="harbour_dues_form"
  [formGroup]="form()"
  [ngClass]="{
    'was-validated': showValidationErrors(),
    'disabled': !canEdit(),
    'enabled': canEdit()
  }"
>
  @if (isAdmin()) {
    <app-harbour-dues-admin
      [declaration]="selectedDeclaration()"
    />
  }

  <app-harbour-dues-info
    [declarationTabs]="declarationTabs()"
    [selectedDeclaration]="selectedDeclaration()"
    [visit]="visit()"
  />

  @if (declarationSelected()) {
    <app-reduction-rotterdam
      [harbourDuesDetails]="harbourDuesDetails()"
      [isHarbourDuesAdvisor]="isHarbourDuesAdvisor()"
    />

    @if (hasBerthVisits()) {
      <app-berth-details-rotterdam
        [visit]="visit()"
        [selectedDeclaration]="selectedDeclaration()"
        [harbourDuesDetails]="harbourDuesDetails()"
        [vesselDeadWeightKg]="vesselDeadWeightKg()"
        [showValidationErrors]="showValidationErrors()"
      />
    }

    @if (isAccepted() && selectedDeclaration().invoices?.length) {
      <app-harbour-dues-costs
        [selectedDeclaration]="selectedDeclaration()"/>
    }

    @if (
      (isAccepted() && hasCurrentVersionInvoice())
      || (!isDeclared())
      || (isDeclared() && validProFormaDisplayed())
    ) {
      <app-harbour-dues-rotterdam-pro-forma
        [selectedDeclaration]="selectedDeclaration()"
        (validProFormaDisplayed)="validProFormaDisplayed.set($event)"
        (proFormaRequested)="proFormaRequested.emit()"
      />
    }
  }

</form>
